import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import { ValidationProvider } from 'vee-validate';
// import {ValidationObserver} from 'vee-validate'
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate/dist/vee-validate.full';
Vue.component('ValidationObserver',ValidationObserver)
Vue.component('ValidationProvider',ValidationProvider)
Vue.config.productionTip = false
// Check local storage to handle refreshes
/*
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
  }
}
*/

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount('#app')

